import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
const Circle = ({
  cx,
  cy,
  r,
  fill,
  id,
  theme
}) => /* @__PURE__ */ jsx("circle", { cx, cy, r, fill: fill || theme.constellation.colors.blue500, id, className: "rd3-linechart-circle" });
Circle.propTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  fill: PropTypes.string,
  r: PropTypes.number,
  id: PropTypes.string,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  theme: PropTypes.object
};
const Circle$1 = withTheme(Circle);
export {
  Circle$1 as default
};
